import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  Chip,
  Stack,
  Divider
} from '@mui/material';
import format from 'date-fns/format';
import { setMask } from 'utils';

const ExternalChargeDetailsTable = ({ externalCharge, onRefund }) => {
  const getStatusChip = (status) => {
    const statusMap = {
      sent: { label: 'Enviado', color: 'warning' },
      partially_recovered: { label: 'Parcialmente Recuperado', color: 'info' },
      recovered: { label: 'Recuperado', color: 'success' },
      finished: { label: 'Finalizado', color: 'default' },
      canceled: { label: 'Cancelado', color: 'error' }
    };
    const config = statusMap[status] || { label: status, color: 'default' };
    return <Chip label={config.label} color={config.color} size="small" />;
  };

  const canRefund = externalCharge.status === 'recovered' && externalCharge.valueToRefund > 0 && !externalCharge.refunded;

  const renderSection = (title, rows, columns = ['Campo', 'Valor']) => (
    <Box sx={{ mb: 3 }}>
      <Typography variant="h6" sx={{ mb: 2, color: 'primary.main', fontWeight: 'bold' }}>
        {title}
      </Typography>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              {
                columns.map((column, index) => (
                  <TableCell key={index} sx={{ whiteSpace: 'nowrap' }}><strong>{column}</strong></TableCell>
                ))
              }
            </TableRow>
          </TableHead>
          <TableBody>
            {rows}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );

  return (
    <Box>
      {/* Resumo do Contrato */}
      {renderSection('Resumo do Contrato', [
        <TableRow key="status">
          <TableCell sx={{ whiteSpace: 'nowrap' }}>Status</TableCell>
          <TableCell>{getStatusChip(externalCharge.status)}</TableCell>
        </TableRow>,
        <TableRow key="totalValue">
          <TableCell sx={{ whiteSpace: 'nowrap' }}>Valor Total do Contrato</TableCell>
          <TableCell>
            <Typography variant="h6" color="primary.main">
              {setMask('money', externalCharge.totalContractValue || 0)}
            </Typography>
          </TableCell>
        </TableRow>,
        <TableRow key="parcels">
          <TableCell sx={{ whiteSpace: 'nowrap' }}>Parcelas</TableCell>
          <TableCell>
            <Typography
              color={externalCharge.recoveredInstallments === externalCharge.totalInstallments ? 'success.main' : 'text.primary'}
            >
              {externalCharge.recoveredInstallments} de {externalCharge.totalInstallments} pagas
            </Typography>
          </TableCell>
        </TableRow>,
        <TableRow key="pending">
          <TableCell sx={{ whiteSpace: 'nowrap' }}>Parcelas Pendentes</TableCell>
          <TableCell>{externalCharge.pendingInstallments}</TableCell>
        </TableRow>
      ])}

      {/* Cobrança Externa (Ledger) */}
      {renderSection('Cobrança Externa', [
        // <TableRow key="service">
        //   <TableCell sx={{ whiteSpace: 'nowrap' }}>Serviço de Recuperação</TableCell>
        //   <TableCell>{externalCharge.recoveryService === 'payhop' ? 'PayHop' : 'Manual'}</TableCell>
        // </TableRow>,
        <TableRow key="feeRate">
          <TableCell sx={{ whiteSpace: 'nowrap' }}>Taxa de Recuperação</TableCell>
          <TableCell>{(externalCharge.recoveryFee * 100).toFixed(1)}%</TableCell>
        </TableRow>,
        <TableRow key="sendDate">
          <TableCell sx={{ whiteSpace: 'nowrap' }}>Data de Envio</TableCell>
          <TableCell sx={{ fontSize: { xs: '0.875rem', sm: 'inherit' } }}>
            {format(new Date(externalCharge.sendDatetime), 'dd/MM/yyyy HH:mm')}
          </TableCell>
        </TableRow>,
        ...(externalCharge.totalRecovered > 0 ? [
          <TableRow key="recovered">
            <TableCell sx={{ whiteSpace: 'nowrap' }}>Total Recebido via Cobrança Externa</TableCell>
            <TableCell>
              <Typography sx={{ color: 'success.main' }}>
                {setMask('money', externalCharge.totalRecovered)}
              </Typography>
            </TableCell>
          </TableRow>
        ] : []),
        // ...(externalCharge.totalFee > 0 ? [
        //   <TableRow key="fees">
        //     <TableCell sx={{ whiteSpace: 'nowrap' }}>Total Taxas de Serviço</TableCell>
        //     <TableCell>
        //       <Typography sx={{ color: 'error.main' }}>
        //         -{setMask('money', externalCharge.totalFee)}
        //       </Typography>
        //     </TableCell>
        //   </TableRow>
        // ] : []),
        // ...(externalCharge.totalSettled > 0 ? [
        //   <TableRow key="fees">
        //     <TableCell sx={{ whiteSpace: 'nowrap' }}>Total Utilizado para Abatimento</TableCell>
        //     <TableCell>
        //       <Typography sx={{ color: 'error.main' }}>
        //         -{setMask('money', externalCharge.totalSettled)}
        //       </Typography>
        //     </TableCell>
        //   </TableRow>
        // ] : []),
        // ...(externalCharge.totalAvailable > 0 && externalCharge.status !== 'recovered'? [
        //   <TableRow key="netAvailable">
        //     <TableCell sx={{ whiteSpace: 'nowrap' }}>Total Disponível para Abatimento</TableCell>
        //     <TableCell>
        //       <Typography sx={{ color: 'primary.main' }}>
        //         {setMask('money', externalCharge.totalAvailable)}
        //       </Typography>
        //     </TableCell>
        //   </TableRow>
        // ] : []),
        // ...(externalCharge.valueToRefund > 0 ? [
        //   <TableRow key="toRefund" sx={{ backgroundColor: '#e8f5e8' }}>
        //     <TableCell sx={{ whiteSpace: 'nowrap' }}>Saldo para Reembolso</TableCell>
        //     <TableCell>
        //       <Typography>
        //         {setMask('money', externalCharge.valueToRefund)}
        //       </Typography>
        //     </TableCell>
        //   </TableRow>
        // ] : [])
      ])}

      {/* Cobrança OpenPix */}
      {/* {renderSection('Cobrança OpenPix', [
        ...(externalCharge.totalCreditUsed > 0 ? [
          <TableRow key="creditUsed">
            <TableCell sx={{ whiteSpace: 'nowrap' }}>Total Utilizado em Cobrança OpenPix</TableCell>
            <TableCell>
              <Typography sx={{ color: 'error.main' }}>
                -{setMask('money', externalCharge.totalCreditUsed)}
              </Typography>
            </TableCell>
          </TableRow>
        ] : []),
      ])} */}

      {/* Informações Adicionais */}
      {/* {renderSection('Informações Adicionais', [
        ...(externalCharge.refunded && externalCharge.refundDatetime ? [
          <TableRow key="refundDate">
            <TableCell sx={{ whiteSpace: 'nowrap' }}>Data do Reembolso</TableCell>
            <TableCell sx={{ fontSize: { xs: '0.875rem', sm: 'inherit' } }}>
              {format(new Date(externalCharge.refundDatetime), 'dd/MM/yyyy HH:mm')}
            </TableCell>
          </TableRow>
        ] : []),
        ...(externalCharge.externalId ? [
          <TableRow key="externalId">
            <TableCell sx={{ whiteSpace: 'nowrap' }}>ID Externo</TableCell>
            <TableCell sx={{
              wordBreak: 'break-word',
              fontSize: { xs: '0.875rem', sm: 'inherit' }
            }}>
              {externalCharge.externalId}
            </TableCell>
          </TableRow>
        ] : []),
        ...(externalCharge.observation ? [
          <TableRow key="observation">
            <TableCell sx={{ whiteSpace: 'nowrap', verticalAlign: 'top' }}>Observação</TableCell>
            <TableCell sx={{
              wordBreak: 'break-word',
              fontSize: { xs: '0.875rem', sm: 'inherit' }
            }}>
              {externalCharge.observation}
            </TableCell>
          </TableRow>
        ] : [])
      ])} */}

      {/* Lançamentos */}
      {renderSection('Lançamentos',
        externalCharge.externalChargeList.length > 0 ? [
          ...externalCharge.externalChargeList.map((item) => (
           <TableRow key={item.id}>
              <TableCell sx={{ whiteSpace: 'nowrap' }}>
                {format(new Date(item.recoveryDate), 'dd/MM/yyyy')}
              </TableCell>
              <TableCell sx={{ fontSize: { xs: '0.875rem', sm: 'inherit' } }}>
                {setMask('money', item.amountReceived)}
              </TableCell>
            </TableRow>
          ))
        ] : [], ['Data', 'Valor'])
      }

      {canRefund && onRefund && (
        <Stack direction="row" justifyContent="center" mt={3}>
          <Typography
            variant="body2"
            color="success.main"
            sx={{
              fontWeight: 'bold',
              mb: 2,
              textAlign: 'center',
              fontSize: { xs: '0.875rem', sm: 'inherit' }
            }}
          >
            Todas as parcelas foram quitadas! Valor disponível para reembolso: {setMask('money', externalCharge.valueToRefund)}
          </Typography>
        </Stack>
      )}
    </Box>
  );
};

export default ExternalChargeDetailsTable;